import {AbstractDTO} from "@signature-it/ngx-generic/models";

export class EntityTypeData extends AbstractDTO{
    id: boolean;
    name: string;
    entity_type_var: string;
    is_tree: boolean;

    constructor(attributes?: object) {
        super(attributes);
        attributes = attributes ? attributes : {};
        this.id = attributes['id'] || '';
        this.name = attributes['additional_notification_data_property_2_s'] || '';
        this.entity_type_var = attributes['entity_type_var'] || '';
        this.is_tree = attributes['is_tree'] || '';
    }
}
